import { creativeSaga } from './creative.saga'
import { addressSaga } from './address.saga'
import { reportSaga } from './report.saga'
import { platformSaga } from './platform.saga'
import { logsSaga } from './logs.saga'
import { contractSaga } from './contracts.saga'
import { organizationSaga } from './organizations.saga'
import { statusesSaga } from './statuses.saga'

export const advertisementSagas = [
	organizationSaga(),
	contractSaga(),
	creativeSaga(),
	addressSaga(),
	reportSaga(),
	platformSaga(),
	logsSaga(),
	statusesSaga(),
]
